import { render } from "./UserDropDown.vue?vue&type=template&id=f26c5140"
import script from "./UserDropDown.vue?vue&type=script&lang=js"
export * from "./UserDropDown.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/studiostvapp/studiostvapp/PlatformStudiosApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__